import { createSelector } from 'reselect';

const selectSettlementPayouts = (state: any) => state.settlementPayouts;


export const selectSettlementPayoutCurrentItem = createSelector([selectSettlementPayouts], (settlementPayouts) => settlementPayouts.current);

export const selectSettlementPayoutsListItems = createSelector([selectSettlementPayouts], (settlementPayouts) => settlementPayouts.list);

export const selectSettlementPayoutItemById = (itemId: any) =>
    createSelector(selectSettlementPayoutsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSettlementPayoutQueryItems = createSelector([selectSettlementPayouts], (settlementPayouts) => settlementPayouts.query);

export const selectSettlementPayoutCreatedItem = createSelector([selectSettlementPayouts], (settlementPayouts) => settlementPayouts.create);

export const selectSettlementPayoutUpdatedItem = createSelector([selectSettlementPayouts], (settlementPayouts) => settlementPayouts.update);

export const selectSettlementPayoutReadItem = createSelector([selectSettlementPayouts], (settlementPayouts) => settlementPayouts.read);

export const selectSettlementPayoutDeletedItem = createSelector([selectSettlementPayouts], (settlementPayouts) => settlementPayouts.delete);

export const selectSettlementPayoutSearchedItems = createSelector([selectSettlementPayouts], (settlementPayouts) => settlementPayouts.search);

export const selectSettlementPayoutItemsCount = createSelector([selectSettlementPayouts], (settlementPayouts) => settlementPayouts.count);

export const selectSettlementPayoutItemsFilter = createSelector([selectSettlementPayouts], (settlementPayouts) => settlementPayouts.filter);